// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5c97ca75","239":"e0d75032","453":"80863eb3","732":"20b9d8e3"}[chunkId] + ".chunk.js";
};